import { Tooltip } from 'antd';
import { Info } from '@phosphor-icons/react';
import { IPropsMaiorPosicao } from '../../../@types/CarteiraCreditoProps';
import { transformMaskCurrency } from '../../../../../utils/transformMaskCurrency';
import { chartHelpText } from '../../../../../social/constants';
import { TableContainer, TableTitle, Table } from './styles';

interface IPropsMaioresPosicoes {
  data: IPropsMaiorPosicao[];
}

function shortenName(nome: string, maxLen = 32) {
  if (!nome) return '-';
  return nome.length > maxLen ? `${nome.slice(0, maxLen - 1).trim()}…` : nome;
}

export const MaioresPosicoes = ({ data = [] }: IPropsMaioresPosicoes) => {
  return (
    <TableContainer>
      <TableTitle>
        Maiores posições
        <Tooltip title={chartHelpText.maioresPosicoes}>
          <Info size="1rem" color="#EC6643" />
        </Tooltip>
      </TableTitle>

      {!data || data.length === 0 ? (
        <div
          style={{
            textAlign: 'center',
            padding: '1rem 0',
            color: '#6B7280',
            fontSize: '0.875rem',
          }}
        >
          Dados da carteira de crédito não disponíveis para este fundo.
        </div>
      ) : (
        <Table>
          <thead>
            <tr>
              <th>Securitizadora</th>
              <th>Código IF</th>
              <th>Valor</th>
              <th>% da carteira</th>
            </tr>
          </thead>
          <tbody>
            {data.slice(0, 10).map((item, index) => (
              <tr key={`${item.codigo_if || 'sem-codigo'}-${index}`}>
                <td>{shortenName(item.securitizadora)}</td>
                <td>{item.codigo_if || '-'}</td>
                <td>{transformMaskCurrency(Number(item.valor) || 0)}</td>
                <td>{`${(Number(item.percentual) || 0)
                  .toFixed(2)
                  .replace('.', ',')}%`}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </TableContainer>
  );
};
